/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiFormControlLabelStyle = (): Components<Theme>["MuiFormControlLabel"] => ({
  styleOverrides: {
    label: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
});
